/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobUpdateResponse {
    getFixupPrototypeFunction() { return TemplateJobUpdateResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobUpdateResponse>): TemplateJobUpdateResponse {
        let obj = Object.assign(new TemplateJobUpdateResponse(), model);
        TemplateJobUpdateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobUpdateResponse>): TemplateJobUpdateResponse {
        if (!model) return null;
        return TemplateJobUpdateResponse.newInstance(<TemplateJobUpdateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobUpdateResponse) {
        if (!obj) return;

        models.TemplateJobUpdateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobUpdateResponse): boolean {
        Object.setPrototypeOf(obj, TemplateJobUpdateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.completed_at === "string") {
            this.completed_at = new Date(<string><any>this.completed_at);
        }
        if (this.resources) {
            for (let val of this.resources) {
                models.TemplateJobResource.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique ID of the Template Job
     */
    id: string;

    /**
     * Name of the Template Job
     */
    name: string;

    /**
     * Overall status of the template execution
     */
    status: models.TemplateJobStatus;

    /**
     * Error message if failed
     */
    status_reason: string;

    /**
     * Template Job start time in UTC
     */
    created_at: Date;

    /**
     * Template Job completion time in UTC
     */
    completed_at: Date;

    /**
     * Template Job execution type
     */
    execution_type: models.TemplateExecutionType;

    /**
     * Terraform Template state
     */
    terraform_state: string;

    /**
     * Template Job execution template inputs arguments
     */
    args: { [key: string]: string; };

    /**
     * Template Job outputs
     */
    output: string;

    /**
     * Terraform job log ID
     */
    attachment_id: string;

    resources: Array<models.TemplateJobResource>;

}
